import { useMemo } from "react";
import { XCircle } from "lucide-react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { useLanguage } from "@/context/LanguageContext";
import { ordersLabels } from "@/i18n";

interface ContractSignatureFailureDialogProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  description?: string;
}

export const ContractSignatureFailureDialog = ({
  isOpen,
  onClose,
  title: titleOverride,
  description: descriptionOverride,
}: ContractSignatureFailureDialogProps) => {
  const { language } = useLanguage();
  const o = useMemo(() => ordersLabels(language), [language]);
  const title = titleOverride ?? o.signatureFailure?.title ?? "Signering avbruten";
  const description =
    descriptionOverride ??
    o.signatureFailure?.description ??
    "Signeringen slutfördes inte. Du kan försöka igen från ordern om signering fortfarande behövs.";

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[420px] border-none bg-transparent shadow-none">
        <div className="flex flex-col items-center justify-center py-12 space-y-6 bg-white dark:bg-gray-900 rounded-lg">
          <div className="relative">
            <XCircle className="h-24 w-24 text-red-500 animate-in zoom-in duration-500" />
            <div className="absolute inset-0 bg-red-500 rounded-full animate-ping opacity-20" />
            <div className="absolute inset-0 bg-red-500/15 rounded-full animate-pulse" />
          </div>
          <div className="text-center space-y-2">
            <p className="text-2xl font-bold text-red-600 dark:text-red-400 animate-in fade-in duration-500">
              {title}
            </p>
            <p className="text-sm text-gray-600 dark:text-gray-400 animate-in fade-in duration-700">
              {description}
            </p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
